import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import * as Icons from '../icons/Icons';
import Button from '../../sharedComponents/Button';

const DisplayTemplate = ({ children, onEditClick, isDisabled, label }) => (
    <div className="rec-display-wrap">
        <div className={cx("rec-display-plain-text", {
            "disabled": isDisabled
        })}>
            {children}
        </div>
        <Button
            appearance="tertiary"
            className="rec-edit-button"
            isDisabled={isDisabled}
            onClick={onEditClick}
            iconBeforeElement={<Icons.IconEdit />}
            screenReaderTextBefore={label ? `Click to edit ${label} content` : 'Click to edit content'} />
    </div>
);

DisplayTemplate.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.any),
        PropTypes.string,
        PropTypes.node
    ]),
    onEditClick: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    label: PropTypes.string
};

DisplayTemplate.defaultProps = {};

export default DisplayTemplate;
